import { queryOptions, useMutation } from "@tanstack/react-query";

import {
  CompanyPutRequest,
  CountryToPopulatorFieldsItem,
  getCompany,
  getCountries,
  updateCompanyDetail,
} from "@/generated/api/users";

const useUpdateCompanyMutation = () =>
  useMutation({
    mutationFn: ({ id, ...payload }: CompanyPutRequest & { id: number }) =>
      updateCompanyDetail(id, payload),
    mutationKey: ["company", "update"],
  });

const companyQuery = ({ companyId }: { companyId: number }) =>
  queryOptions({
    queryFn: async ({ signal }) => {
      const countries = await getCountries({ signal });
      const company = await getCompany(companyId, { signal });

      return [countries, company] as const;
    },
    queryKey: ["company-info", companyId],
    select: ([countries, company]) => {
      const disabledFields =
        countries.find((country) => country.id === company.country)
          ?.populatorFields ?? [];

      return {
        company,
        disabledFields: mapPopulatorFields(disabledFields),
      } as const;
    },
  });

const mapPopulatorFields = (populatorFields: CountryToPopulatorFieldsItem[]) =>
  populatorFields.map((field) => {
    switch (field) {
      case "VAT":
        return "vat";
      case "FORM":
        return "legalForm";
      case "ADDRESS":
        return "address";
    }
  });

export { companyQuery, useUpdateCompanyMutation };
